/** @deprecated Use BusinessFunctionsScreen. Kept for deep links. */
import { DeprecatedSettingsRedirectScreen } from './DeprecatedSettingsRedirectScreen';

export const CapabilityBreakdownScreen = () => (
  <DeprecatedSettingsRedirectScreen target="BusinessFunctions" />
);
